import { FormConfig } from 'components/common/form/FormConfig';
import { SiteAnnouncementFormData } from 'core/siteAnnouncement/SiteAnnouncement';
import { FormikContextType, useFormikContext } from 'formik';
import i18n from 'i18n';
import { Fragment, useCallback, useMemo } from 'react';
import { Form } from 'components/common/form/Form';
import { Button } from 'react-bootstrap';

export const SiteAnnouncementFormContent: React.FC<{
  onCancel: () => void;
  formConfigGetter: (
    formikProps: FormikContextType<SiteAnnouncementFormData>
  ) => FormConfig;
}> = ({ onCancel, formConfigGetter }) => {
  const formikProps = useFormikContext<SiteAnnouncementFormData>();
  const formConfig = useMemo(
    () => formConfigGetter(formikProps),
    [formikProps, formConfigGetter]
  );

  const renderFormBtns = useCallback(
    () => (
      <Fragment>
        <Form.SubmitButton>{i18n.t('common.buttons.review')}</Form.SubmitButton>
        <Button size='sm' variant='secondary' onClick={onCancel}>
          {i18n.t('common.buttons.cancel')}
        </Button>
      </Fragment>
    ),
    [onCancel]
  );

  return (
    <Form
      formikProps={formikProps}
      formConfig={formConfig}
      renderFormBtns={renderFormBtns}
    />
  );
};
